import { Form } from "react-bootstrap"
import { memo, useState } from "react"

import capitalise from "../../utils/capitalise"

const UpdateControlInput = memo((props) => {
  const {
    setValue,
    setValid,
    validTest,
    value,
    type,
    isValid,
    name,
    ...inputProps
  } = props

  const [showEmptyError, setShowEmptyError] = useState(false)
  const handleChange = (e) => {
    setValue(e.target.value)
    setValid(validTest(e.target.value.trim()))
    if (e.target.value.trim()) setShowEmptyError(false)
  }

  const handleBlur = (e) => {
    if (!e.target.value.trim()) setShowEmptyError(true)
  }

  return (
    <Form.Group>
      <Form.Control
        isInvalid={(!isValid && value.trim()) || showEmptyError}
        value={value}
        onBlur={handleBlur}
        onChange={handleChange}
        type={type}
        {...inputProps}
      />
      <Form.Control.Feedback type="invalid" className="fw-semibold">
        <i>{!value.trim() ? `${capitalise(name)} is required` : `Please enter a valid ${name}`}</i>
      </Form.Control.Feedback>
    </Form.Group>
  )
})

export default UpdateControlInput